import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: 'Main',
		meta: { layout: 'admin-auth', public: true, title: 'Вакансии Национальной компании "КазМунайГаз"' },
		component: () => import('@/views/External/Main/Index.vue')
	},
	// {
	// 	path: '/main2',
	// 	name: 'Old Main Page',
	// 	meta: { layout: 'external', public: true, title: 'Вакансии Национальной компании "КазМунайГаз"' },
	// 	component: () => import('@/views/External/MainOld/Index.vue')
	// },
	{
		path: '/login',
		name: 'Login',
		meta: { layout: 'external', public: true, title: 'Авторизация' },
		component: () => import('@/views/External/Auth/Login.vue')
	},
	{
		path: '/registration',
		name: 'Registration',
		meta: { layout: 'external', public: true, title: 'Регистрация' },
		component: () => import('@/views/External/Auth/Register.vue')
	},
	{
		path: '/reset_password',
		name: 'Reset Password Via Email',
		meta: { layout: 'external', public: true, title: 'Сброс пароля' },
		component: () => import('@/views/External/Auth/ResetPasswordViaEmail.vue')
	},
	{
		path: '/password_reset/confirm/:token',
		name: 'Reset Password',
		meta: { layout: 'external', public: true, title: 'Сброс пароля' },
		component: () => import('@/views/External/Auth/ResetPassword.vue')
	},
	{
		path: '/user/confirm/:uidb64/:token',
		name: 'Confirm Register User',
		meta: { layout: 'external', public: true, title: 'Подтверждение регистрации' },
		component: () => import('@/views/External/Auth/ConfirmRegister.vue')
	},
	{
		path: '/change_password',
		name: 'Change Password',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Изменение пароля' },
		component: () => import('@/views/External/Auth/ChangePassword.vue')
	},
	{
		path: '/about',
		name: 'About',
		meta: { layout: 'external', public: true, title: 'О компании' },
		component: () => import('@/views/External/Info/About.vue')
	},
	{
		path: '/steps',
		name: 'Steps',
		meta: { layout: 'external', public: true, title: 'Этапы отбора' },
		component: () => import('@/views/External/Info/Steps.vue')
	},
	{
		path: '/for_students',
		name: 'For Students',
		meta: { layout: 'external', public: true, title: 'Студентам' },
		component: () => import('@/views/External/Info/Students.vue')
	},
	{
		path: '/faq',
		name: 'FAQ',
		meta: { layout: 'external', public: true, title: 'Вопросы и ответы' },
		component: () => import('@/views/External/Info/Faq.vue')
	},
	{
		path: '/notifications',
		name: 'Notifications',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Уведомления' },
		component: () => import('@/views/External/Info/Notifications.vue')
	},
	{
		path: '/vacancies',
		name: 'Vacancies',
		meta: { layout: 'external', public: true, title: 'Вакансии' },
		component: () => import('@/views/External/Vacancies/Index.vue')
	},
	{
		path: '/vacancies/:id',
		name: 'Show Vacancy',
		meta: { layout: 'external', public: true, title: 'Просмотр вакансии' },
		component: () => import('@/views/External/Vacancies/Show.vue')
	},
	{
		path: '/resume/create',
		name: 'Create Resume',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Создание резюме' },
		component: () => import('@/views/External/Account/CreateEditResume.vue')
	},
	{
		path: '/resume/edit',
		name: 'Edit Resume',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Изменение резюме' },
		component: () => import('@/views/External/Account/CreateEditResume.vue')
	},
	{
		path: '/my_responses',
		name: 'My Responses',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Мои отклики' },
		component: () => import('@/views/External/Account/MyResponses.vue')
	},
	{
		path: '/responses/:id',
		name: 'Show Vacancy in Response',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Просмотр вакансии' },
		component: () => import('@/views/External/Vacancies/Show.vue')
	},
	{
		path: '/my_resume',
		name: 'My Resume',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Резюме' },
		component: () => import('@/views/External/Account/MyResume.vue')
	},
	{
		path: '/subscribes',
		name: 'Subscribes',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Подписки' },
		component: () => import('@/views/External/Account/Subscribes.vue')
	},
	{
		path: '/personal-info/:vacancy_id',
		name: 'Send Personal Info',
		meta: { layout: 'external', requiresAuth: 'user', title: 'Персональные данные' },
		component: () => import('@/views/External/PersonalInfo/Index.vue')
	},
	{
		path: '/contacts',
		name: 'Contacts',
		meta: { layout: 'external', public: true, title: 'Контакты' },
		component: () => import('@/views/External/Info/Contacts.vue')
	},

	{
		path: '/admin/login',
		name: 'Admin Login',
		meta: { layout: 'external', public: true, title: 'Авторизация' },
		component: () => import('@/views/External/Auth/Login.vue')
	},
	{
		path: '/admin',
		name: 'Admin Main',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Главная' },
		component: () => import('@/views/AdminPanel/Main/Index.vue')
	},
	{
		path: '/admin/notifications',
		name: 'Admin Notifications',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Уведомления' },
		component: () => import('@/views/AdminPanel/Notifications/Index.vue')
	},
	{
		path: '/admin/users',
		name: 'Admin Users',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Пользователи' },
		component: () => import('@/views/AdminPanel/Users/Index.vue')
	},
	{
		path: '/admin/users/add',
		name: 'Admin Add Users',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Добавление пользователя' },
		component: () => import('@/views/AdminPanel/Users/Create.vue')
	},
	{
		path: '/admin/vacancies/:status',
		name: 'Admin Vacancies',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Вакансии' },
		component: () => import('@/views/AdminPanel/Vacancies/Index.vue')
	},
	{
		path: '/admin/vacancies/add',
		name: 'Create Vacancies',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Создание вакансии' },
		component: () => import('@/views/AdminPanel/Vacancies/CreateOrEditVacancy.vue')
	},
	{
		path: '/admin/vacancies/:status/edit/:id',
		name: 'Edit Vacancy',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Изменение вакансии' },
		component: () => import('@/views/AdminPanel/Vacancies/CreateOrEditVacancy.vue')
	},
	{
		path: '/admin/vacancies/:status/show/:id',
		name: 'Admin Show Vacancy',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Просмотр вакансии' },
		component: () => import('@/views/AdminPanel/Vacancies/Show.vue')
	},
	{
		path: '/admin/vacancies/:id/stages',
		name: 'Vacancy Stages',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Этапы отбора' },
		component: () => import('@/views/AdminPanel/Vacancies/Stages.vue')
	},
	{
		path: '/admin/resume/:mark',
		name: 'Admin Resume',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'База резюме' },
		component: () => import('@/views/AdminPanel/Resume/Index.vue')
	},
	{
		path: '/admin/resume/coordination',
		name: 'Admin Coordination',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Согласование статусов' },
		component: () => import('@/views/AdminPanel/Resume/Coordination.vue')
	},
	{
		path: '/admin/resume/:mark/show/:id',
		name: 'Admin Resume Show',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Просмотр резюме' },
		component: () => import('@/views/AdminPanel/Resume/Show.vue')
	},
	{
		path: '/admin/resume/apply/:id',
		name: 'Apply Resume for a vacancy',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Направление на вакансию' },
		component: () => import('@/views/AdminPanel/Resume/Apply.vue')
	},
	{
		path: '/admin/resume/commanders/create',
		name: 'Admin Resume Add Business Trip',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Добавить прикомандированных' },
		component: () => import('@/views/AdminPanel/Resume/Create.vue')
	},
	{
		path: '/admin/resume/edit/:id',
		name: 'Admin Resume Edit',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Редактировать резюме' },
		component: () => import('@/views/AdminPanel/Resume/Create.vue')
	},
	{
		path: '/admin/resume/passport',
		name: 'Admin Passport List',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Список паспортов' },
		component: () => import('@/views/AdminPanel/Resume/Passport/List.vue')
	},
	{
		path: '/admin/resume/passport/:id',
		name: 'Admin Passport Detail',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Паспорт' },
		component: () => import('@/views/AdminPanel/Resume/Passport/Index.vue')
	},
	{
		path: '/admin/blacklist',
		name: 'Blacklist',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Черный список' },
		component: () => import('@/views/AdminPanel/Resume/Blacklist.vue')
	},
	{
		path: '/admin/directories/:code/:parent?',
		name: 'Directories',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Справочники' },
		component: () => import('@/views/AdminPanel/Directories/Index.vue')
	},
	{
		path: '/admin/tools/updates',
		name: 'Changelog',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Журнал изменений' },
		component: () => import('@/views/AdminPanel/Changelog/Index.vue')
	},
	{
		path: '/admin/tools/updates/:id',
		name: 'Changelog Show or Edit',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Просмотр журнала' },
		component: () => import('@/views/AdminPanel/Changelog/ShowOrEdit.vue')
	},
	{
		path: '/admin/students',
		name: 'Admin Students',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Обращения студентов' },
		component: () => import('@/views/AdminPanel/Students/Index.vue')
	},
	{
		path: '/admin/students/:id',
		name: 'Student Request',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Просмотр обращения' },
		component: () => import('@/views/AdminPanel/Students/Show.vue')
	},
	{
		path: '/admin/students/add',
		name: 'Add Student Request',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Создать обращение' },
		component: () => import('@/views/AdminPanel/Students/Show.vue')
	},
	{
		path: '/admin/feedback',
		name: 'Admin Feedback',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Обратная свзяь' },
		component: () => import('@/views/AdminPanel/Feedback/Index.vue')
	},
	{
		path: '/admin/feedback/:id',
		name: 'Feedback Show or Edit',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Просмотр обращения' },
		component: () => import('@/views/AdminPanel/Feedback/Show.vue')
	},
	{
		path: '/admin/feedback/add',
		name: 'Add Feedback',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Создание обращения' },
		component: () => import('@/views/AdminPanel/Feedback/Create.vue')
	},
	{
		path: '/admin/subscribes',
		name: 'Admin Subscribes',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Подписки' },
		component: () => import('@/views/AdminPanel/Subscribes/Index.vue')
	},
	{
		path: '/admin/settings/text',
		name: 'Admin Text Setting',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Настройка текстов' },
		component: () => import('@/views/AdminPanel/Settings/Texts.vue')
	},
	{
		path: '/admin/settings/messages',
		name: 'Admin Messages',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Сообщения' },
		component: () => import('@/views/AdminPanel/Settings/Messages.vue')
	},
	{
		path: '/admin/settings/requests',
		name: 'Admin User Requests',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Запросы' },
		component: () => import('@/views/AdminPanel/Settings/Requests.vue')
	},
	{
		path: '/admin/settings/types',
		name: 'Admin Journal Types',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Типы журналов' },
		component: () => import('@/views/AdminPanel/Settings/Types.vue')
	},
	{
		path: '/admin/report/vacancies',
		name: 'Admin Report Vacancies',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Отчет по вакансиям' },
		component: () => import('@/views/AdminPanel/Reports/Vacancies.vue')
	},
	{
		path: '/admin/report/resume',
		name: 'Admin Report Resume',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Отчет по резюме' },
		component: () => import('@/views/AdminPanel/Reports/Resume.vue')
	},
	{
		path: '/admin/report/students',
		name: 'Admin Report Students',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Отчет по студентам' },
		component: () => import('@/views/AdminPanel/Reports/Students.vue')
	},
	{
		path: '/admin/report/unloading',
		name: 'Admin Reports Unloading',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Выгрузка' },
		component: () => import('@/views/AdminPanel/Reports/Unloading.vue')
	},
	{
		path: '/admin/tools/mailings',
		name: 'Admin Mailings',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Сообщения' },
		component: () => import('@/views/AdminPanel/Tools/Mailings.vue')
	},
	{
		path: '/admin/content/pages',
		name: 'Admin Content Pages',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Контент' },
		component: () => import('@/views/AdminPanel/Content/Pages.vue')
	},
	{
		path: '/admin/content/pages/:type',
		name: 'Admin Show or Edit Content Pages',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Контент' },
		component: () => import('@/views/AdminPanel/Content/ShowPages.vue')
	},
	{
		path: '/admin/profile',
		name: 'Profile',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Профиль' },
		component: () => import('@/views/AdminPanel/Profile/Index.vue')
	},
	{
		path: '/admin/logs',
		name: 'Logs',
		meta: { layout: 'admin', requiresAuth: 'admin', title: 'Logs' },
		component: () => import('@/views/AdminPanel/Logs/Index.vue')
	},
	{
		path: '/404',
		name: 'Not Found',
		meta: { layout: 'external', public: true, title: 'Страница не найдена' },
		component: () => import('@/views/External/Empty/Index.vue')
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title || 'WORK KMG';
  
	const token = localStorage.getItem('token');
	const isAuthenticated = !!token;
	const roles = localStorage.getItem('role') ?? '';
  
	const isExternalUser = roles.includes('USER');
	const isAdminUsers = !isExternalUser;
  
	if (to.meta.public) {
	  	return next();
	}
  
	if (!isAuthenticated) {
	  	return next({ path: '/login', query: { redirect: to.fullPath } });
	}
  
	if (isExternalUser) {
		if (to.meta.requiresAuth === 'user') {
			return next(); 
		} else {
			return next('/404');
		}
	}
  
	if (isAdminUsers) {
		if (to.meta.requiresAuth === 'admin') {
			return next(); 
		} else {
			return next('/404');
		}
	}
  
	next('/404');
});
  

export default router
